import { FeatureSidebarButton } from '@lmt/signal-viewer-ui';
import { openSeparateWindow } from '../utils/separate-window';

const SeparateWindowIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M14.5 2.99902C15.8806 2.99902 16.9998 4.1185 17 5.49902V14.499C17 15.8797 15.8807 16.999 14.5 16.999H9.5C9.22389 16.999 9 16.7751 9 16.499C9.00046 16.2233 9.22417 15.9991 9.5 15.999H14.5C15.3284 15.999 16 15.3274 16 14.499V5.49902C15.9998 4.67079 15.3283 3.99902 14.5 3.99902H5.5C4.67174 3.99906 4.00023 4.67081 4 5.49902V10.499C4 10.7752 3.77614 10.999 3.5 10.999C3.22389 10.999 3 10.7751 3 10.499V5.49902C3.00023 4.11852 4.11946 2.99906 5.5 2.99902H14.5Z'
        fill='currentColor'
      />
      <path
        d='M10.5 12.5V9.5H7.5M10.5 9.5L5.5 14.5'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const SeparateWindowButton: React.FC = () => {
  return (
    <FeatureSidebarButton
      icon={<SeparateWindowIcon />}
      label='Separate window'
      onClick={() => openSeparateWindow()}
    />
  );
};
